import { Factory } from 'rosie';

Factory.define('AgentRead');

Factory.define('AgentReadWithDefaults')
  .extend('AgentRead')
  .attr('conversationId', 'conversation-id')
  .attr('agentId', 'agent-id')
  .attr('readTo', new Date().toISOString());
